module.exports = __webpack_public_path__ + "835ffb127d176b9820f51c4f7551453a.svg";